import { Component, Input } from '@angular/core'

@Component({
  selector: 'app-info-edital-inscricao',
  templateUrl: './info-edital-inscricao.component.html',
})
export class InfoEditalInscricaoComponent {
  @Input()
  tituloEdital: string
  @Input()
  tipoResidencia: string
  @Input()
  tempoRestante: string
  @Input()
  descricaoSituacaoEdital: string
}
